import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { enfilerLecture, installerFileLectures } from '../../utils/lectureQueue';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const Euros = ({ v }) => <>{Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €</>;

export const joursAvantDepart = (d) => {
  if (!d) return null;
  return Math.round((new Date(d + 'T00:00:00') - new Date(new Date().toDateString())) / 86400000);
};

// Iter 579 (Kamel) — ✈️ formalités « Mon billet d'avion » : à transmettre au plus tard 60 jours avant le départ.
export const limiteFormalites = (dateDepart) => {
  if (!dateDepart) return null;
  const d = new Date(dateDepart + 'T00:00:00');
  d.setDate(d.getDate() - 60);
  return { date: d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }), depassee: d < new Date(new Date().toDateString()) };
};

// Iter 469 (Kamel) — 📋 formalités & choix paramétrés dans l'admin, cochés par l'adhérent (ESTA, repas avion…).
export const fmtLimite = (iso) => iso ? new Date(iso).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
export const QuestionsBlock = ({ token, regId, initial }) => {
  const [qs, setQs] = useState(initial);
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState('');
  const [ouvertes, setOuvertes] = useState({});
  const repondre = async (q, vi, valeur) => {
    setBusy(`${q.id}-${vi}`);
    setQs(prev => prev.map(x => x.id !== q.id ? x : { ...x, reponses: x.reponses.map(r => r.vi === vi ? { ...r, valeur } : r) }));
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/fiche/${regId}/questions/${q.id}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ vi, valeur }),
      });
      const j = await r.json();
      if (!r.ok) { alert(j.detail || 'Erreur'); setQs(initial); } else { setQs(j.questions); setMsg('✅ Réponse enregistrée — merci !'); setTimeout(() => setMsg(''), 3000); }
    } catch { alert('Erreur réseau — réessayez.'); }
    setBusy('');
  };
  // Iter 500 (Kamel) — 📄 formalité « document » : photo (appareil) ou PDF déposé par l'adhérent, validé ensuite par l'association.
  const deposer = async (q, vi, file) => {
    if (!file) return;
    setBusy(`${q.id}-${vi}`);
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('vi', vi == null ? '' : String(vi));
      const r = await fetch(`${API}/espace-adherent/${token}/fiche/${regId}/questions/${q.id}/document`, { method: 'POST', body: fd });
      const j = await r.json();
      if (!r.ok) alert(j.detail || 'Erreur'); else { setQs(j.questions); setMsg('✅ Document bien reçu — l\'association va le vérifier.'); setTimeout(() => setMsg(''), 4000); }
    } catch { alert('Erreur réseau — réessayez.'); }
    setBusy('');
  };
  const manquantes = qs.reduce((n, q) => n + q.reponses.filter(r => r.valeur == null || r.valeur === '' || r.valeur === false).length, 0);
  return (
    <div className="bg-violet-50 border border-violet-300 rounded-xl p-3 space-y-2.5" data-testid={`fiche-questions-${regId}`}>
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-bold text-[#1E3A5F]">📋 À compléter pour votre voyage</p>
        {manquantes > 0
          ? <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-100 text-red-700 border border-red-300" data-testid={`fiche-questions-manquantes-${regId}`}>{manquantes} réponse{manquantes > 1 ? 's' : ''} attendue{manquantes > 1 ? 's' : ''}</span>
          : <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 border border-emerald-300">✅ tout est complété</span>}
      </div>
      {msg && <p className="text-[11px] font-bold text-emerald-700" data-testid="fiche-questions-msg">{msg}</p>}
      {qs.map(q => {
        const manque = q.reponses.filter(r => r.valeur == null || r.valeur === '' || r.valeur === false).length;
        const estOuverte = ouvertes[q.id] === true;
        return (
        <div key={q.id} className="bg-white border border-violet-200 rounded-lg p-2.5" data-testid={`question-${q.id}`}>
          <button type="button" onClick={() => setOuvertes(o => ({ ...o, [q.id]: !estOuverte }))} className="w-full flex items-center justify-between gap-2 text-left" data-testid={`question-toggle-${q.id}`}>
            <span className="text-xs font-bold text-[#1E3A5F] leading-snug">{q.type === 'case' ? '☑' : q.type === 'document' ? '📄' : '🔘'} {q.label}{q.obligatoire && <span className="text-red-500"> *</span>}</span>
            <span className="flex items-center gap-1.5 shrink-0">
              {manque > 0 ? <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-100 text-red-700">{manque > 1 ? `${manque} à faire` : 'à faire'}</span>
                : <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700">✅</span>}
              <span className="text-[#1E3A5F]">{estOuverte ? '▴' : '▾'}</span>
            </span>
          </button>
          {estOuverte && <>
          {q.description && <p className="text-[11px] text-gray-600 mt-0.5 leading-snug">{q.description}</p>}
          {(q.liens || []).filter(l => l.url).map((l, i) => (
            <a key={i} href={l.url} target="_blank" rel="noreferrer"
              className="inline-block mt-1.5 mr-2 text-[11px] font-bold px-3 py-1.5 rounded-lg bg-[#1E3A5F] text-white hover:bg-[#2a4d7a]"
              data-testid={`question-lien-${q.id}-${i}`}>{l.fichier ? '📄' : '🔗'} {l.label || l.url} ↗</a>
          ))}
          {q.limite && (
            <p className={`text-[11px] font-bold mt-0.5 ${q.clos ? 'text-red-600' : 'text-amber-700'}`} data-testid={`question-limite-${q.id}`}>
              {q.clos ? `🔒 Délai dépassé (${fmtLimite(q.limite)}) — contactez l'association` : `⏰ À compléter avant le ${fmtLimite(q.limite)}`}
            </p>
          )}
          <div className="mt-1.5 space-y-1.5">
            {q.reponses.map(r => {
              const key = `${q.id}-${r.vi}`;
              const verrou = q.clos || (q.validation_admin && r.valide);
              return (
                <div key={key} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px]" data-testid={`question-rep-${q.id}-${r.vi}`}>
                  {q.par_voyageur && <span className="font-semibold w-36 truncate">{r.nom}</span>}
                  {q.type === 'document' ? (
                    <span className="flex flex-wrap items-center gap-1.5" data-testid={`question-doc-${q.id}-${r.vi}`}>
                      {r.doc && <a href={`${API}/espace-adherent/${token}/document/${r.doc.id}`} target="_blank" rel="noreferrer" className="font-bold text-[#1E3A5F] underline" data-testid={`question-doc-voir-${q.id}-${r.vi}`}>📄 {r.doc.filename || 'Mon document'} ↗</a>}
                      {!verrou && (
                        <label className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-lg font-bold cursor-pointer ${r.doc ? 'bg-gray-100 text-gray-700 border' : 'bg-[#1E3A5F] text-white'} ${busy === key ? 'opacity-50' : ''}`}>
                          {busy === key ? '⏳ Envoi…' : r.doc ? '🔁 Remplacer' : '📷 Photo / 📄 Fichier'}
                          <input type="file" accept="image/*,application/pdf" className="hidden" disabled={busy === key}
                            onChange={e => deposer(q, r.vi, e.target.files?.[0])} data-testid={`question-doc-input-${q.id}-${r.vi}`} />
                        </label>
                      )}
                      {!r.doc && <span className="text-gray-500">à déposer</span>}
                    </span>
                  ) : q.type === 'case' ? (
                    <label className={`flex items-center gap-1.5 ${verrou ? 'opacity-70' : 'cursor-pointer'}`}>
                      <input type="checkbox" checked={r.valeur === true} disabled={verrou || busy === key}
                        onChange={e => repondre(q, r.vi, e.target.checked)} className="w-4 h-4 accent-emerald-600" data-testid={`question-check-${q.id}-${r.vi}`} />
                      <span>{r.valeur === true ? 'Oui, c\'est fait' : 'Pas encore'}</span>
                    </label>
                  ) : (
                    <select value={r.valeur || ''} disabled={verrou || busy === key} onChange={e => repondre(q, r.vi, e.target.value)}
                      className={`border rounded-lg px-2 py-1 text-[11px] ${r.valeur ? 'border-emerald-400 bg-emerald-50 font-bold' : 'border-red-300 bg-red-50'}`} data-testid={`question-select-${q.id}-${r.vi}`}>
                      <option value="">— Choisir —</option>
                      {q.options.map(o => <option key={o} value={o}>{o}</option>)}
                    </select>
                  )}
                  {q.validation_admin && (r.valeur === true || (q.type === 'document' && r.doc)) && (
                    r.valide
                      ? <span className="font-bold text-emerald-700" data-testid={`question-valide-${q.id}-${r.vi}`}>✅ validé par l'association</span>
                      : <span className="font-bold text-amber-700" data-testid={`question-attente-${q.id}-${r.vi}`}>⏳ en attente de validation par l'association</span>
                  )}
                </div>
              );
            })}
          </div>
          </>}
        </div>
        );
      })}
    </div>
  );
};

// Iter 462 (Kamel) — ✅ « On la joue collectif » : rappel à l'ouverture de ce qui reste à cocher avant le départ (rien n'est bloqué).
export const ChecklistDepart = ({ fiches, charteAt, onAller }) => {
  const [ferme, setFerme] = useState(false);
  const aVenir = (fiches || []).filter(f => f.statut === 'à venir');
  if (!aVenir.length || ferme) return null;
  const notes = aVenir.reduce((n, f) => n + (f.notes_voyage || (f.note_voyage ? [f.note_voyage] : [])).filter(x => !x.lu_at && !x.perimee).length, 0);
  const questions = aVenir.reduce((n, f) => n + (f.questions || []).reduce((m, q) => m + (q.reponses || []).filter(r => r.valeur == null || r.valeur === '' || r.valeur === false).length, 0), 0);
  const rubriques = aVenir.reduce((n, f) => n + (f.rubriques_perso || []).filter(r => !r.vue_at).length, 0);
  const charte = charteAt ? 0 : 1;
  // Iter 578 (Kamel) — ✈️ formalités « Mon billet d'avion » (bloquant convocation) et 🚌 places de bus non choisies
  // alors que le règlement est OK (journée soldée / acompte versé) : rappel EN HAUT, non fermable tant que c'est en attente.
  const fichesFormalites = aVenir.filter(f => f.pieces && !f.pieces.transmis);
  const fichesBus = aVenir.filter(f => f.bus && f.bus.lien && !f.bus.attente_reglement && !f.bus.bientot && ((!f.bus.places || f.bus.places.length === 0) || (f.bus.trajets || []).some(t => !t.places.length)));
  const formalites = fichesFormalites.length;
  const bus = fichesBus.length;
  const bloquant = formalites + bus > 0;
  const total = notes + questions + rubriques + charte + formalites + bus;
  const liens = { formalites: fichesFormalites[0]?.pieces?.lien, bus: fichesBus[0]?.bus?.lien };
  const aller = (k) => { if (liens[k]) { window.location.href = liens[k]; return; } onAller?.(k); };
  return (
    <div className={`rounded-xl shadow border-2 p-3 ${bloquant ? 'bg-red-50 border-red-500' : total ? 'bg-amber-50 border-amber-400' : 'bg-emerald-50 border-emerald-400'}`} data-testid="espace-checklist-depart">
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm font-bold text-[#1E3A5F]">{bloquant ? '⚠️ À faire avant le départ — indispensable' : '🤝 On la joue collectif — avant le départ, tout doit être coché'}</p>
        {!bloquant && <button onClick={() => setFerme(true)} className="text-gray-400 text-lg leading-none" aria-label="Fermer" data-testid="espace-checklist-fermer">×</button>}
      </div>
      {total === 0 ? (
        <p className="text-xs text-emerald-800 mt-1 font-bold">✅ Notes lues, questions complétées, infos ouvertes, charte approuvée — merci, tout est en ordre !</p>
      ) : (
        <ul className="mt-2 space-y-1.5 text-[13px] text-amber-950">
          {[
            ...(aVenir.some(f => f.pieces) ? [['formalites', formalites, "✈️ Mon billet d'avion", formalites ? (() => {
              const f0 = fichesFormalites[0]; const lim = limiteFormalites(f0?.date_depart);
              return `informations passeport à transmettre${formalites > 1 ? ` (${formalites} voyages)` : f0?.voyage ? ` (${f0.voyage})` : ''}${lim ? (lim.depassee ? ' — ⏰ délai dépassé, faites-le aujourd\'hui' : ` — au plus tard le ${lim.date} (60 jours avant le départ)`) : ''} · indispensable pour recevoir votre convocation de départ`;
            })() : 'informations passeport transmises']] : []),
            ...(aVenir.some(f => f.bus && f.bus.lien) ? [['bus', bus, '🚌 Mes places dans le car', bus ? `à choisir maintenant (${bus > 1 ? `${bus} voyages` : fichesBus[0]?.voyage || ''}) — votre règlement est enregistré, les meilleures places partent vite` : 'choisies']] : []),
            ['notes', notes, 'Notes destination', notes ? `${notes} à lire puis « J'ai bien lu »` : 'toutes lues'],
            ['questions', questions, 'Questions / formalités', questions ? `${questions} réponse${questions > 1 ? 's' : ''} attendue${questions > 1 ? 's' : ''}` : 'complétées'],
            ...(aVenir.some(f => (f.rubriques_perso || []).length) ? [['rubriques', rubriques, "Infos de l'équipe", rubriques ? `${rubriques} rubrique${rubriques > 1 ? 's' : ''} à ouvrir` : 'toutes ouvertes']] : []),
            ['charte', charte, 'Charte du voyageur', charte ? '« Lu et approuvé » à cocher' : 'approuvée'],
          ].map(([k, n, titre, detail]) => {
            const urgent = k === 'formalites' || k === 'bus';
            return (
            <li key={k} data-testid={`espace-checklist-${k}`}>
              {n ? (
                /* Iter 904 — mobile : une ligne = une carte pleine largeur, bouton « y aller » bien visible */
                <button type="button" onClick={() => aller(k)}
                  className={`w-full text-left rounded-lg px-3 py-2.5 flex items-start gap-2.5 border ${urgent ? 'bg-white border-red-300' : 'bg-white/80 border-amber-200'}`}
                  data-testid={`espace-checklist-aller-${k}`}>
                  <span className="text-base leading-none mt-0.5" aria-hidden>⬜</span>
                  <span className="flex-1 min-w-0 leading-snug">
                    <strong className={urgent ? 'text-red-800' : 'text-[#1E3A5F]'}>{titre}</strong>
                    <span className="block text-xs text-gray-700 mt-0.5">{detail}</span>
                  </span>
                  <span className={`shrink-0 self-center text-xs font-bold px-2.5 py-1.5 rounded-full text-white ${urgent ? 'bg-red-600' : 'bg-[#1E3A5F]'}`}>y aller →</span>
                </button>
              ) : <span className="flex items-start gap-2 px-1"><span aria-hidden>✅</span><span><strong>{titre}</strong> : {detail}</span></span>}
            </li>
            );
          })}
        </ul>
      )}
      {formalites > 0 && (
        <p className="text-[11px] text-gray-700 mt-2 bg-white/70 rounded-lg p-2" data-testid="espace-checklist-passeport-bienveillant">
          🛂 <strong>Passeport périmé, bientôt périmé ou en cours de renouvellement ?</strong> Pas d'inquiétude : transmettez dès maintenant ce que vous avez et prévenez-nous, on s'organise ensemble. Pensez à la validité (souvent 6 mois après le retour) et aux délais en mairie (4 à 8 semaines).
        </p>
      )}
      <p className="text-[10px] text-gray-500 mt-1.5">📊 Les sondages : réponse vivement souhaitée, ça nous aide à organiser.</p>
    </div>
  );
};


// Iter 654 (Kamel) — 🖼️ visionneuse plein écran des photos d'une note (galerie) : fermer, précédente / suivante, légende
export const Lightbox = ({ images, index, onIndex, onClose, regId }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); if (e.key === 'ArrowRight') onIndex((index + 1) % images.length); if (e.key === 'ArrowLeft') onIndex((index - 1 + images.length) % images.length); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [index, images.length, onClose, onIndex]);
  const img = images[index];
  // portail sur <body> : passe au-dessus de l'en-tête du site, du chat et des bannières
  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-black/90 flex flex-col" onClick={onClose} data-testid={`fiche-note-lightbox-${regId}`}>
      <div className="flex items-center justify-between px-3 py-2 text-white text-xs">
        <span className="font-bold truncate" data-testid="lightbox-legende">{img.label || 'Photo'}{images.length > 1 ? ` · ${index + 1}/${images.length}` : ''}</span>
        <button type="button" onClick={onClose} className="px-3 py-1.5 rounded-full bg-white/15 font-bold" data-testid="lightbox-fermer">✕ Fermer</button>
      </div>
      <div className="flex-1 min-h-0 flex items-center justify-center px-2 pb-3">
        <img src={img.url} alt={img.label || ''} className="max-w-full max-h-full object-contain rounded-lg" onClick={e => e.stopPropagation()} />
      </div>
      {images.length > 1 && (
        <div className="flex justify-between px-3 pb-4" onClick={e => e.stopPropagation()}>
          <button type="button" onClick={() => onIndex((index - 1 + images.length) % images.length)} className="px-4 py-2 rounded-full bg-white/15 text-white text-sm font-bold" data-testid="lightbox-prec">‹ Précédente</button>
          <a href={img.url} target="_blank" rel="noreferrer" className="px-4 py-2 rounded-full bg-white/15 text-white text-sm font-bold" data-testid="lightbox-ouvrir">Ouvrir ↗</a>
          <button type="button" onClick={() => onIndex((index + 1) % images.length)} className="px-4 py-2 rounded-full bg-white/15 text-white text-sm font-bold" data-testid="lightbox-suiv">Suivante ›</button>
        </div>
      )}
    </div>,
    document.body
  );
};

// Iter 466 (Kamel) — 📌 note de destination repliable : titre + 2 premiers points, « Lire la suite » pour le reste.
export const NoteVoyage = ({ f, n, idx = 0, token }) => {
  // Iter 618 — lien direct ?notes=1[&note=ID] : la note ciblée (ou toutes les non-lues) arrive déjà dépliée
  const [ouvert, setOuvert] = useState(() => {
    const q = new URLSearchParams(window.location.search);
    if (q.get('notes') !== '1') return false;
    const cible = q.get('note');
    return cible ? cible === n.id : !n.lu_at;
  });
  const [luAt, setLuAt] = useState(n.lu_at || null);
  const [busyLu, setBusyLu] = useState(false);
  // Iter 481 (Kamel) — 👁 suivi de lecture : « vue » dès l'affichage, « lu » au clic « J'ai bien lu ».
  const [horsLigne, setHorsLigne] = useState(false);
  const marquer = useCallback(async (action) => {
    if (!token || !n.id) return null;
    const at = new Date().toISOString();
    try {
      const r = await fetch(`${API}/espace-adherent/${token}/note/${n.id}/lecture`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ reg_id: f.reg_id, action, at }) });
      if (r.ok) return (await r.json()).lu_at;
      if (r.status >= 500) throw new Error('serveur');
      return null;
    } catch {
      // Iter 649 — pas de réseau : on mémorise, ça partira tout seul au retour de la connexion
      enfilerLecture({ token, note_id: n.id, reg_id: f.reg_id, action, at });
      return action === 'lu' ? { at, horsLigne: true } : null;
    }
  }, [token, n.id, f.reg_id]);
  useEffect(() => { installerFileLectures(); marquer('vue'); }, [marquer]);
  useEffect(() => {
    const ok = () => setHorsLigne(false);
    window.addEventListener('raav-lectures-envoyees', ok);
    return () => window.removeEventListener('raav-lectures-envoyees', ok);
  }, []);
  const jaiLu = async () => {
    setBusyLu(true);
    const res = await marquer('lu');
    if (res && typeof res === 'object') { setLuAt(res.at); setHorsLigne(true); } else if (res) setLuAt(res);
    setBusyLu(false);
  };
  const lignes = n.lignes || [];
  const sections = n.sections || [];
  const nbCache = lignes.length + sections.reduce((s, x) => s + 1 + (x.lignes || []).length, 0);
  const images = (n.liens || []).filter(l => l.image && l.url);
  const nbImages = images.length;
  const [zoom, setZoom] = useState(null);  // Iter 654 — index de la photo agrandie (galerie)
  const longue = nbCache > 0 || (n.liens || []).length > 0;
  const visibles = ouvert ? lignes : [];
  const nouvelle = !luAt && !n.perimee;  // Iter 650 — pas encore « J'ai bien lu » = mise en avant
  const dateNote = n.date_note ? n.date_note.split('-').reverse().join('/') : '';
  return (
    <div className={`border rounded-xl p-3 space-y-1.5 scroll-mt-32 ${n.perimee ? 'bg-gray-50 border-gray-200 opacity-70' : nouvelle ? 'bg-amber-50 border-amber-400 border-2 shadow-md' : 'bg-sky-50 border-sky-300'}`} id={n.id ? `note-${n.id}` : undefined} data-testid={`fiche-note-voyage-${f.reg_id}`} data-nouvelle={nouvelle ? '1' : '0'}>
      {/* Iter 461 — mobile : seul le titre est visible, on déplie au toucher */}
      <button type="button" onClick={() => setOuvert(o => !o)} className="w-full flex items-center justify-between gap-2 text-left" data-testid={`fiche-note-toggle-${f.reg_id}${idx ? `-${idx}` : ''}`}>
        <span className={`text-xs font-bold leading-snug ${n.perimee ? 'text-gray-500' : 'text-[#1E3A5F]'}`}>
          {nouvelle && <span className="inline-block mr-1.5 text-[10px] font-extrabold px-1.5 py-0.5 rounded bg-red-600 text-white align-middle animate-pulse" data-testid={`fiche-note-nouveau-${n.id}`}>NOUVEAU</span>}
          {n.epinglee && !n.perimee && <span className="inline-block mr-1.5 text-[10px] font-bold px-1.5 py-0.5 rounded bg-[#1E3A5F] text-white align-middle" data-testid={`fiche-note-epinglee-${n.id}`}>📍 Épinglée</span>}
          📌 {n.titre || 'Information importante'}
          {n.perimee ? <span className="ml-1 text-[10px] font-bold text-gray-500" data-testid={`fiche-note-perimee-${n.id}`}>· passée ({n.valable_jusquau.split('-').reverse().join('/')})</span>
            : n.valable_jusquau ? <span className="ml-1 text-[10px] font-bold text-amber-700">· valable jusqu'au {n.valable_jusquau.split('-').reverse().join('/')}</span> : null}
          {dateNote && <span className="block text-[10px] font-normal text-gray-500" data-testid={`fiche-note-date-${n.id}`}>publiée le {dateNote}{nbImages > 0 && !ouvert ? ` · 🖼️ ${nbImages} image${nbImages > 1 ? 's' : ''}` : ''}</span>}</span>
        <span className="flex items-center gap-1.5 shrink-0">
          {luAt ? <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700">✅ lu</span>
            : <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-500 text-white">à lire</span>}
          <span className="text-[#1E3A5F]">{ouvert ? '▴' : '▾'}</span>
        </span>
      </button>
      {visibles.length > 0 && (
        <ul className="mt-1.5 space-y-1">
          {visibles.map((l, i) => <li key={i} className="text-[11px] text-sky-950 leading-snug">• {l}</li>)}
        </ul>
      )}
      {ouvert && sections.map((s, si) => (
        <div key={si} className="mt-2.5">
          <p className="text-[11px] font-bold text-[#1E3A5F]">{s.titre}</p>
          <ul className="mt-0.5 space-y-0.5">
            {(s.lignes || []).map((l, i) => <li key={i} className="text-[11px] text-sky-950 leading-snug">• {l}</li>)}
          </ul>
        </div>
      ))}
      {ouvert && images.length > 0 && (
        <div className={`mt-2 grid gap-1.5 ${images.length === 1 ? 'grid-cols-1' : 'grid-cols-2 sm:grid-cols-3'}`} data-testid={`fiche-note-galerie-${f.reg_id}`}>
          {images.map((l, i) => (
            <button type="button" key={`img${i}`} onClick={() => setZoom(i)} className="block text-left min-w-0" data-testid={`fiche-note-image-${f.reg_id}-${i}`}>
              <img src={l.url} alt={l.label || ''} loading="lazy" className={`w-full rounded-xl border border-sky-200 bg-white object-cover ${images.length === 1 ? 'max-h-72 object-contain' : 'aspect-square'}`} />
              {l.label && <span className="block text-[10px] text-gray-500 text-center mt-0.5 truncate">{l.label}</span>}
            </button>
          ))}
          <span className="col-span-full text-[10px] text-gray-400 text-center">appuyez sur une photo pour l'agrandir</span>
        </div>
      )}
      {zoom !== null && <Lightbox images={images} index={zoom} onIndex={setZoom} onClose={() => setZoom(null)} regId={f.reg_id} />}
      {ouvert && (n.liens || []).filter(l => !l.image).map((l, i) => (
        <a key={i} href={l.url} target="_blank" rel="noreferrer"
          className="inline-block mt-2 mr-2 text-[11px] font-bold px-3 py-1.5 rounded-lg bg-[#1E3A5F] text-white hover:bg-[#2a4d7a]"
          data-testid={`fiche-note-lien-${f.reg_id}-${i}`}>{l.fichier ? '📄' : '🔗'} {l.label || l.url} ↗</a>
      ))}
      {ouvert && longue && (
        <button onClick={() => setOuvert(false)} className="mt-2 text-[11px] font-bold text-[#1E3A5F] underline decoration-sky-400 underline-offset-2">▴ Replier</button>
      )}
      {n.id && (ouvert || !luAt) && (
        <div className="pt-1.5 mt-1 border-t border-sky-200">
          {luAt ? (
            <p className="text-[11px] font-bold text-emerald-700" data-testid={`fiche-note-lu-${f.reg_id}-${idx}`}>✅ Vous avez confirmé la lecture le {new Date(luAt).toLocaleDateString('fr-FR')}
              {horsLigne && <span className="block font-normal text-amber-700" data-testid={`fiche-note-lu-attente-${f.reg_id}-${idx}`}>📶 Enregistré sur votre téléphone — sera transmis automatiquement dès que le réseau revient.</span>}</p>
          ) : (
            <button onClick={jaiLu} disabled={busyLu}
              className="text-[11px] font-bold px-3 py-1.5 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50"
              data-testid={`fiche-note-jai-lu-${f.reg_id}-${idx}`}>✅ J'ai bien lu cette information</button>
          )}
        </div>
      )}
    </div>
  );
};

